const isObject = (val: unknown): val is Record<string, unknown> =>
  typeof val === "object" && val !== null && !Array.isArray(val);

type ImageLike = Record<string, unknown> & {
  url?: string;
  width?: number;
  height?: number;
};

const hasWidthAndHeight = (
  obj: Record<string, unknown>,
): obj is ImageLike & { width: number; height: number } =>
  "url" in obj &&
  typeof obj.width === "number" &&
  typeof obj.height === "number" &&
  obj.height > 0;

const gcd = (a: number, b: number): number => (b === 0 ? a : gcd(b, a % b));

const toAspectRatioString = (width: number, height: number): string => {
  const divisor = gcd(width, height);
  return `${width / divisor} / ${height / divisor}`;
};

export const rebuildAspectRatio = (obj: unknown): unknown => {
  if (isObject(obj)) {
    const n: Record<string, unknown> = {};

    Object.keys(obj).forEach((k) => {
      n[k] = rebuildAspectRatio(obj[k]);
    });

    if (hasWidthAndHeight(obj)) {
      return {
        ...n,
        aspectRatio: toAspectRatioString(obj.width, obj.height),
      };
    }

    return n;
  }

  if (Array.isArray(obj)) {
    return obj.map((i) => rebuildAspectRatio(i));
  }

  return obj;
};
